export const sum = (numbers: number[]) =>
  numbers.reduce((sum, value) => sum + value, 0)

export function uniq<T>(array: readonly T[]): T[] {
  return Array.from(new Set(array))
}
